import { useState, useEffect } from "react";

const SessionCountdown = ({ expirationTime }) => {
  const expirationTimeInSeconds = Number(expirationTime);
  const [countdownString, setCountdownString] = useState(getTokenCountdownString());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdownString(getTokenCountdownString());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  function formatWithLeadingZero(value) {
    return value < 10 ? `0${value}` : value;
  }

  function getTokenCountdownString() {
    let timeRemaining = expirationTimeInSeconds - Math.floor(Date.now() / 1000);

    let minutes = Math.floor((timeRemaining % 3600) / 60);
    let seconds = timeRemaining % 60;

    if(timeRemaining < 0) {
      minutes = "0"
      seconds = "00"
    }
    // const formattedMinutes = formatWithLeadingZero(minutes);
    const formattedSeconds = formatWithLeadingZero(seconds);

    return `Time remaining: ${minutes}m ${formattedSeconds}s`;
  }

  return (
    <div>
      <p>{countdownString}</p>
    </div>
  );
};

export default SessionCountdown;